import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row
} from 'react-bootstrap';

import { formatDate } from '../helpers/formatting';
import { isEmail } from '../helpers/validation';
import validateInviteAction from '../actions/validateInviteAction';

import '../App.css';

export default function RegisterForm(props) {
  const [emailInvalid, setEmailInvalid] = useState(false);
  const [passwordInvalid, setPasswordInvalid] = useState(false);
  const [businessNameInvalid, setBusinessNameInvalid] = useState(false);
  const [inviteCodeInvalid, setInviteCodeInvalid] = useState(false);

  const handleValidateChange = async e => {
    switch (e.target.name) {
      case 'email':
        setEmailInvalid(!isEmail(e.target.value));
        return;
        break;
      case 'password':
        if (!e.target.value || e.target.value.length < 8) {
          setPasswordInvalid(true);
          return;
        } else {
          setPasswordInvalid(false);
        }
        break;
      case 'businessName':
        if (!e.target.value) {
          setBusinessNameInvalid(true);
          return;
        } else {
          setBusinessNameInvalid(false);
        }
        break;
      case 'inviteCode':
        if (!e.target.value) {
          setInviteCodeInvalid(false);
          return;
        } else {
            //setShowCreateSpinner(true);
            const response = await validateInviteAction({
              code: e.target.value,
            });
            if(!!response.success) {
              setInviteCodeInvalid(false);
            } else {
              setInviteCodeInvalid(true);
              return;
            }
        } 
        break;
    }
    //props.handleChange(e.target.name, e.target.value);
  }



  return (
    <Container fluid className="text-start mt-3 mt-md-5">
      <Row>
        <Col></Col>
        <Col xs={12} sm={8}>
          <Card>
            <Card.Body>
              <Form noValidate>
                <Form.Group className="mb-3" controlId="formFirstName">
                  <Form.Label>Email</Form.Label>
                  <Form.Control 
                    isInvalid={emailInvalid} 
                    type="text" 
                    placeholder="Enter email address" 
                    name="email" 
                    defaultValue={props.email} 
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a valid email address.
                  </Form.Control.Feedback>                  
                </Form.Group>

                <Form.Group className="mb-3" controlId="formLastName">
                  <Form.Label>Password</Form.Label>
                  <Form.Control 
                    isInvalid={passwordInvalid} 
                    type="password" 
                    placeholder="Enter password" 
                    name="password" 
                    defaultValue={props.password} 
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a password at least 8 characters long.
                  </Form.Control.Feedback>                  
                </Form.Group>

                <Form.Group className="mb-3" controlId="formAddress">
                  <Form.Label>Business Name</Form.Label>
                  <Form.Control 
                    isInvalid={businessNameInvalid} 
                    type="text" 
                    placeholder="Enter your business name" 
                    name="businessName" 
                    defaultValue={props.businessName} 
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter your business name.
                  </Form.Control.Feedback>                  
                </Form.Group>

                <Form.Group className="mb-3" controlId="formZip">
                  <Form.Label>Invite code</Form.Label>
                  <Form.Control 
                    isInvalid={inviteCodeInvalid} 
                    type="text" 
                    placeholder="Enter invite code if you have one" 
                    name="inviteCode" 
                    defaultValue={props.inviteCode} 
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Invalid code.
                  </Form.Control.Feedback>                  
                </Form.Group>

              </Form>
            </Card.Body>
          </Card>
        </Col>
        <Col></Col>
      </Row>
    </Container>
  );
}
